
<template>
  <el-form-item :label="params.label">
    <w-areaid @input="changeArea" :detail="{areaId: regionId}" placeholder="请填写" style="display:inline-block;"></w-areaid>
  </el-form-item>
</template>

<script>
import WAreaid from '@/components/Form/w-areaid'
import { mapGetters } from 'vuex'

export default {
  name: 'form-area',
  components: {
    WAreaid
  },
  props: {
    params: {
      type: Object
    },
    rowData: {
      type: Object
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ]),
    isGlobal() {
      return this.user.areaId === '000000'
    }
  },
  data() {
    return {
      radio: this.rowData ? this.rowData[this.params.key] : this.params.value,
      regionId: this.rowData ? this.rowData.regionId : null,
      area: undefined
    }
  },
  created() {
    // if (!this.isGlobal) {
    //   this.radio = '2'
    // }
    this.radio = '2'
  },
  methods: {
    changeArea(id, item) {
      console.log(id, item)
      this.area = item
    },
    reset() {
      if (this.params.dValue) {
        this.radio = this.params.dValue
      } else {
        this.radio = undefined
      }
    },
    getValue() {
      if (this.radio) {
        return {
          [this.params.key]: this.area,
          radio: this.radio
        }
      }
      return undefined
    }
  },
  watch: {
    radio(nv, ov) {
      const cp = JSON.parse(JSON.stringify(this.params))
      cp.value = nv
      this.$emit('csi', cp)
    }
  }
}
</script>
